<script setup lang="ts">
// COMPOSABLES
const { tt } = useTypedI18n();
const { openLoginModal, closeSessionExpiredModal } = useModals();
const { isMobile } = useResponsive();

// HANDLERS
const login = (): void => {
    closeSessionExpiredModal();
    openLoginModal();
};
</script>

<template>
    <UModal :title="tt('sessionExpired.title')" :fullscreen="isMobile" :dismissible="false" :close="false" v-bind="modalNoDescAriaFixupProps">
        <template #body>
            <p class="text-muted text-center">{{ tt('sessionExpired.description') }}</p>
        </template>
        <template #footer>
            <UButton size="xl" block color="primary" variant="solid" :label="tt('common.login')" @click="login" />
            <UButton size="xl" block color="neutral" variant="link" :label="tt('sessionExpired.close')" @click="closeSessionExpiredModal" />
        </template>
    </UModal>
</template>
